import { Injectable, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ListMentionsService } from '@app/data/mention/list-mentions.service';

@Injectable({ providedIn: 'root' })
export class AppBadgeService {
  private readonly listMentions = inject(ListMentionsService);
  private readonly destroyRef = inject(DestroyRef);

  init(): void {
    if (!('setAppBadge' in navigator)) return;

    this.listMentions.unreadCount$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(count => {
        if (count > 0) {
          navigator.setAppBadge(count);
        } else {
          navigator.clearAppBadge();
        }
      });
  }
}
